export const PREFERENCES_REQUEST = 'PREFERENCES_REQUEST';
export const UPDATE_PREFERENCES_REQUEST = 'UPDATE_PREFERENCES_REQUEST';
export const UPDATE_PREFERENCES_SUCCESS = 'UPDATE_PREFERENCES_SUCCESS';
export const PREFERENCES_SUCCESS = 'PREFERENCES_SUCCESS';
export const REQUEST_FAILURE = 'REQUEST_FAILURE';

export const PREFERENCES_WITHOUT_SITES_REQUEST = 'PREFERENCES_WITHOUT_SITES_REQUEST';
export const PREFERENCES_WITHOUT_SITES_SUCCESS = 'PREFERENCES_WITHOUT_SITES_SUCCESS';
export const REQUEST_WITHOUT_SITES_FAILURE = 'REQUEST_WITHOUT_SITES_FAILURE';

export const GET_USER_OWN_PREFERENCES_REQUEST = 'GET_USER_OWN_PREFERENCES_REQUEST';
export const GET_USER_OWN_PREFERENCES_SUCCESS = 'GET_USER_OWN_PREFERENCES_SUCCESS';
export const GET_USER_OWN_PREFERENCES_FAILURE = 'GET_USER_OWN_PREFERENCES_FAILURE';

export const SET_SOLARGRAF_ACCESS = 'SET_SOLARGRAF_ACCESS';
